/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { IExampleParent } from '../../core/models/common/IExampleParent';
import { IExamplesParent } from '../../core/models/common/IExamplesParent';
import { SetExampleCommand } from './SetExampleCommand';
import { NodePath } from '../../core/models/NodePath';
import { IExample } from '../../core/models/common/IExample';

/**
 * @author eric.wittmann@gmail.com
 * @extends SetExampleCommand
 * @class
 */
export class SetExampleCommand_30 extends SetExampleCommand {
    public _newExampleName : string;

    public _nullExample : boolean;

    public constructor(parent? : any, example? : any, exampleName? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExamplesParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExamplesParent") >= 0)) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null)) {
            let __args = arguments;
            super(<Node><any>parent, example);
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            (() => {
                this._newExampleName = exampleName;
            })();
        } else if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExampleParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExampleParent") >= 0)) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null)) {
            let __args = arguments;
            super(<Node><any>parent, example);
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            (() => {
                this._newExampleName = exampleName;
            })();
        } else if(parent === undefined && example === undefined && exampleName === undefined) {
            let __args = arguments;
            super();
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[SetExampleCommand_30] Executing.");
        this._oldValue = null;
        this._nullExample = false;
        if(!this.isNullOrUndefined(this._newExampleName)) {
            let parent : IExamplesParent = <IExamplesParent><any>this._parentPath.resolve(document);
            if(this.isNullOrUndefined(parent)) {
                return;
            }
            if(this.isNullOrUndefined(parent.getExample(this._newExampleName))) {
                parent.addExample(parent.createExample(this._newExampleName));
                this._nullExample = true;
            } else {
                this._oldValue = parent.getExample(this._newExampleName).getValue();
            }
            parent.getExample(this._newExampleName).setValue(this._newExample);
        } else {
            let parent : IExampleParent = <IExampleParent><any>this._parentPath.resolve(document);
            if(this.isNullOrUndefined(parent)) {
                return;
            }
            this._oldValue = parent.getExample();
            parent.setExample(this._newExample);
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[SetExampleCommand_30] Reverting.");
        if(!this.isNullOrUndefined(this._newExampleName)) {
            let parent : IExamplesParent = <IExamplesParent><any>this._parentPath.resolve(document);
            if(this.isNullOrUndefined(parent)) {
                return;
            }
            if(this._nullExample) {
                parent.removeExample(this._newExampleName);
            } else {
                parent.getExample(this._newExampleName).setValue(this._oldValue);
            }
        } else {
            let parent : IExampleParent = <IExampleParent><any>this._parentPath.resolve(document);
            if(this.isNullOrUndefined(parent)) {
                return;
            }
            parent.setExample(this._oldValue);
            this._oldValue = null;
        }
    }
}
SetExampleCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.SetExampleCommand_30";
SetExampleCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




